import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavService } from "../../../../_services/_nav.service";
import { Politica } from "../../../../_models/politica";
import { PoliticaService } from '../../../../_services/politica.service';
import { PoliticasFilaMatrizVinculaciones } from "../../../../_models/politica-configurada-matriz-fila";
import {CanalComunicacion, Vinculaciones} from '../../../../_enums/enum';
import { PoliticasMatrizVinculaciones } from "../../../../_models/politica-configurada-matriz";
import { ConfirmationService } from "primeng/api";
import {ComunicationComponentsService} from '../../../../_services/comunication-components.service';
import {Subscription} from 'rxjs';
import {ProductoActividad} from '../../../../_models/producto-actividad';

@Component({
  selector: 'app-politica-matriz',
  templateUrl: './politica-matriz.component.html',
  styleUrls: ['./politica-matriz.component.scss']
})
export class PoliticaMatrizComponent implements OnInit {

  @Input() matrizGeneral: boolean = false;
  @Input() politica: Politica;
  @Input() listadoVinculaciones;
  @Input() listado = [];
  @Input() matriz: PoliticasMatrizVinculaciones;
  @Input() esDetalle: boolean = false;
  @Output() guardarPolitica: EventEmitter<boolean> = new EventEmitter();
  @Output() eliminarMatriz: EventEmitter<boolean> = new EventEmitter();
  @Output() listadoMatriz: EventEmitter<PoliticasFilaMatrizVinculaciones[]> = new EventEmitter();

  submittedMatrizGeneral: boolean = false;
  columnasMatriz: any[];
  matrizForm: FormGroup;
  editarMatriz: boolean = false;
  cargandoMatriz: boolean = true;

  // Filas
  filaTitular: any = {};
  filaDeudor: any = {};
  filaCodeudor: any = {};

  subscripcion: Subscription;
  constructor(
    private nav: NavService,
    private fb: FormBuilder,
    private politicaService: PoliticaService,
    private conServicio: ConfirmationService,
  ) { }

  async ngOnInit() {
    console.log(this.esDetalle)
    await this.obtenerFilas()
    await this.cargaMatriz()
  }



  // Obtener filas de la matriz
  obtenerFilas() {
    if (this.matriz && this.matriz.politicasMatrizVinculacionesList && this.matriz.politicasMatrizVinculacionesList.length == 3) {
      this.editarMatriz = true;
      this.filaTitular = this.matriz.politicasMatrizVinculacionesList.find( x => x.codigoVinculacion == Vinculaciones.TITULAR );
      this.filaDeudor = this.matriz.politicasMatrizVinculacionesList.find( x => x.codigoVinculacion == Vinculaciones.DEUDOR_SOLIDARIO );
      this.filaCodeudor = this.matriz.politicasMatrizVinculacionesList.find( x => x.codigoVinculacion == Vinculaciones.CODEUDOR );
    }
  }


  cargaMatriz() {
    this.columnasMatriz = [
      { field: "vinculacion", header: this.nav.buscarMensaje("POLITICAS.LBL_VINCULACION"), sort: false },
      { field: "titular", header: this.nav.buscarMensaje("POLITICAS.LBL_TITULAR"), sort: false },
      { field: "solidario", header: this.nav.buscarMensaje("POLITICAS.LBL_SOLIDARIO"), sort: false },
      { field: "codeudor", header: this.nav.buscarMensaje("POLITICAS.LBL_CODEUDOR"), sort: false }
    ];
    this.matrizForm = this.fb.group({
      // Primera fila
      valorTitular1: [this.filaTitular && this.filaTitular.valorTitular || this.filaTitular.valorTitular == 0 ? this.filaTitular.valorTitular : '', Validators.required],
      valorDeudor1: [this.filaTitular && this.filaTitular.valorDeudor || this.filaTitular.valorDeudor == 0 ? this.filaTitular.valorDeudor : '', Validators.required],
      valorCodeudor1: [this.filaTitular && this.filaTitular.valorCodeudor || this.filaTitular.valorCodeudor == 0 ? this.filaTitular.valorCodeudor : '', Validators.required],
      // Segunda fila
      valorTitular2: [this.filaDeudor && this.filaDeudor.valorTitular || this.filaDeudor.valorTitular == 0 ? this.filaDeudor.valorTitular : '', Validators.required],
      valorDeudor2: [this.filaDeudor && this.filaDeudor.valorDeudor  || this.filaDeudor.valorDeudor == 0 ? this.filaDeudor.valorDeudor : '', Validators.required],
      valorCodeudor2: [this.filaDeudor && this.filaDeudor.valorCodeudor  || this.filaDeudor.valorCodeudor == 0 ? this.filaDeudor.valorCodeudor : '', Validators.required],
      // Tercera fila
      valorTitular3: [this.filaCodeudor && this.filaCodeudor.valorTitular || this.filaCodeudor.valorTitular == 0 ? this.filaCodeudor.valorTitular : '', Validators.required],
      valorDeudor3: [this.filaCodeudor && this.filaCodeudor.valorDeudor  || this.filaCodeudor.valorDeudor == 0 ? this.filaCodeudor.valorDeudor : '', Validators.required],
      valorCodeudor3: [this.filaCodeudor && this.filaCodeudor.valorCodeudor  || this.filaCodeudor.valorCodeudor == 0 ? this.filaCodeudor.valorCodeudor : '', Validators.required],

      // indicadorRestriccionUnidadCredito: [this.matriz && this.matriz.indicadorRestriccionUnidadCredito ? this.matriz.indicadorRestriccionUnidadCredito : null, []],
      indicadorExcluidaddelConteo: [this.matriz && this.matriz.indicadorExcluidaddelConteo ? this.matriz.indicadorExcluidaddelConteo : null, []],
      // indicadorDescarta: [ this.politica  ? this.politica.indicadorDescarta : false ],
    });
    this.cargandoMatriz = false
  }

  async onSubmitMatriz(accion: boolean) {
    this.submittedMatrizGeneral = true;
    if (this.matrizForm.valid) {

      const formulario = this.matrizForm.value;

      let fila: PoliticasFilaMatrizVinculaciones = {};
      let matriz: PoliticasFilaMatrizVinculaciones[] = [];

      let vinculacionTitular = this.listadoVinculaciones.find( x => x.codigo === Vinculaciones.TITULAR );
      let vinculacionDeudor = this.listadoVinculaciones.find( x => x.codigo === Vinculaciones.DEUDOR_SOLIDARIO );
      let vinculacionCodeudor = this.listadoVinculaciones.find( x => x.codigo === Vinculaciones.CODEUDOR );

      // Seteo fila de la vinculacion titular
      fila = {
        idPoliticaMatrizVinculacion: this.matrizGeneral ? null : this.filaTitular.idPoliticaMatrizVinculacion,
        idPolitica: this.politica ? this.politica.idPolitica : null,
        idModalidad: this.matrizGeneral ? null : this.matriz.idModalidad ? this.matriz.idModalidad : this.filaTitular.idModalidad,
        idVinculacion: vinculacionTitular.idLista,
        valorTitular: formulario.valorTitular1,
        valorDeudor: formulario.valorDeudor1,
        valorCodeudor: formulario.valorCodeudor1,
        // indicadorRestriccionUnidadCredito: this.matrizGeneral ? null : formulario.indicadorRestriccionUnidadCredito,
        indicadorExcluidaddelConteo: this.matrizGeneral ? null : formulario.indicadorExcluidaddelConteo,
        indicadorHabilitado: accion ? this.filaTitular.indicadorHabilitado : false
      };
      matriz.push(fila)

      // Seteo fila de la vinculacion deudor
      fila = {
        idPoliticaMatrizVinculacion: this.matrizGeneral ? null : this.filaCodeudor.idPoliticaMatrizVinculacion,
        idPolitica: this.politica ? this.politica.idPolitica : null,
        idModalidad: this.matrizGeneral ? null : this.matriz.idModalidad ? this.matriz.idModalidad : this.filaCodeudor.idModalidad,
        idVinculacion: vinculacionDeudor.idLista,
        valorTitular: formulario.valorTitular2,
        valorDeudor: formulario.valorDeudor2,
        valorCodeudor: formulario.valorCodeudor2,
        // indicadorRestriccionUnidadCredito: this.matrizGeneral ? null : formulario.indicadorRestriccionUnidadCredito,
        indicadorExcluidaddelConteo: this.matrizGeneral ? null : formulario.indicadorExcluidaddelConteo,
        indicadorHabilitado: accion ? this.filaCodeudor.indicadorHabilitado : false
      };
      matriz.push(fila)

      // Seteo fila de la vinculacion codeudor
      fila = {
        idPoliticaMatrizVinculacion: this.matrizGeneral ? null : this.filaDeudor.idPoliticaMatrizVinculacion,
        idPolitica: this.politica ? this.politica.idPolitica : null,
        idModalidad: this.matrizGeneral ? null : this.matriz.idModalidad ? this.matriz.idModalidad : this.filaDeudor.idModalidad,
        idVinculacion: vinculacionCodeudor.idLista,
        valorTitular: formulario.valorTitular3,
        valorDeudor: formulario.valorDeudor3,
        valorCodeudor: formulario.valorCodeudor3,
        // indicadorRestriccionUnidadCredito: this.matrizGeneral ? null : formulario.indicadorRestriccionUnidadCredito,
        indicadorExcluidaddelConteo: this.matrizGeneral ? null : formulario.indicadorExcluidaddelConteo,
        indicadorHabilitado: accion ? this.filaDeudor.indicadorHabilitado : false
      };
      matriz.push(fila)

      if (!this.politica) {
        this.listadoMatriz.emit(matriz);
        this.editarMatriz = true;
        return;
      }

      this.politicaService.bulkMatriz( matriz ).subscribe(
        (response) => {
          if (response) {
            this.listadoMatriz.emit(matriz);
            this.nav.setMesage(4, {
              severity: "success",
              summary: this.nav.buscarMensaje("LBL_INFORMACION"),
              detail: this.nav.buscarMensaje("POLITICAS.MSG_MATRIZACTUALIZADA"),
            });
            this.editarMatriz = true;
          }
        },
        (error) => {
          this.nav.setMesage(3);
        }
      );
    } else {
    }
  }

  get fMatriz() {
    return this.matrizForm.controls;
  }

  habilitarEdicion() {
    this.editarMatriz = false;
  }

  async deshabilitarMatriz() {
    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'POLITICAS.MSG_ELIMINARMATRIZ' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: this.matriz.matriz,
      accept: async () => {
        await this.onSubmitMatriz(false);
        await this.eliminarMatriz.emit();
      },
      reject: () => {
      }
    } );
  }

}
